/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

/// <reference path="./declarations/globals.d.ts" />

import * as angular from 'angular';
import './app/legacy-angularjs';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { setAngularJSGlobal } from '@angular/upgrade/static';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment-variables';
import { windowifier } from './app/legacy-angularjs/windowifier';
import { perf } from './app/plain-javascript/services/perfLog';
import 'src/app/plain-javascript/services/analytics/AnalyticsService';

//loading-timing workaround for angularjs's firebase, eventually switch to the angular module version
import firebase from 'firebase/compat/app';
window.firebase = firebase as any;
import 'firebase/compat/storage';
import 'firebase/compat/database';
import 'firebase/compat/auth';
// firebase.initializeApp(environment.firebase);

//legacy thing for reports
// require('!file-loader?name=[name].[ext]&outputPath=images!images/touchplan-logo.png');
// require('!file-loader?name=[name].[ext]&outputPath=images!images/handshake-dark.svg');

windowifier();
perf.log('app entry point hit');

//pixi perf patch, for some reason I can't load this from the polyfill page
import { EventSystem } from 'pixi.js-legacy';

import { initAnalyticsLib } from './app/plain-javascript/services/analytics/initAnalyticsLib';
import { Ticket } from '@touchplan/common';

Ticket.applicationType = 'frontend';

initAnalyticsLib();
// console.log('---------------- ANALYTICS DISABLED --------------------')
// require("../../test/mock/analytics-mock")

if (environment.production) {
	enableProdMode();
}

setAngularJSGlobal(angular);
// platformBrowserDynamic().bootstrapModule(AppModule, {ngZone: 'noop'})
platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch((err) => console.error(err));
